import { api } from '../plugins/axios';

export default class LayoutService {
	static getNotifications() {
		return api
			.get('/v1/notifications', {
				params: {
					page: 0,
					per_page: 50,
				},
			})
			.then((res) => {
				return res.data.result.notifications;
			});
	}
	static changeLang(locale) {
		return api.post('/user/auth/change-lang', {
			locale,
		});
	}
}
